
import { defineComponent } from "vue";
import { IAcademicTeacherAssigmentModel } from "@/interfaces/modules";
import AcademicTeacherAssigmentService from "@/api/Academic/AcademicTeacherAssigmentService";
import router from "@/router";

export default defineComponent({
  name: "SystemAcademicAssignmentsContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IAcademicTeacherAssigmentModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "TeacherName", label: "Docente", sortable: true },
          { key: "AcademicYearName", label: "Año academico", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IAcademicTeacherAssigmentModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    filteredItems(): IAcademicTeacherAssigmentModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
          (item) =>
            item.TeacherName?.toLowerCase().includes(search)
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await AcademicTeacherAssigmentService.GetTeacherAssignments();
      this.table.loading = false;
    },
    openForm(Id: any) {
      router.push(`academic-assignments-edit/${Id}`);
    }
  },
});
